/** Rooms need a secure context (https or localhost): WebCrypto and WebRTC require it. */
export const canUseRooms = () => globalThis.isSecureContext !== false && Boolean(crypto.subtle);
